(function () {
    'use strict';

    function handleError(rootScope, $compile) {
        return {
            link: function (scope, elem, attr) {
                //attach a method so the event raised from custom http interceptor
                scope.$on('response_error', function (e, status) {
                    var el = angular.element('<div class="row"><div class="col-md-12"><h2>An Error Was Encountered</h2></div></div><div class="row margin-top-25">' +
                        '<div class="col-md-12"><h3>We\'re sorry, but the aplication encountered an error. Our support team has been notified. </h3></div></div>');
                    var compiledEl = $compile(el)(scope);
                    $(elem).replaceWith(compiledEl);
                });
            }
        };
    }

    handleError.$inject = ['$rootScope', '$compile'];

    angular.module('ecap.common').directive('handleError', handleError);
})();